import React, { useEffect } from 'react';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import AnimatedSection from '../Common/AnimatedSection';
import WarrantyStatementSection from './WarrantyStatementSection';
import WarrantyCoverage from './WarrantyCoverage';
import WarrantyTerms from './WarrantyTerms';
import WarrantyMaintenance from './WarrantyMaintenance';
import { WarrantyExclusions } from './WarrantyExclusions';
import { WarrantyPhilosophy } from './WarrantyPhilosophy';
import { WarrantyFaq } from './WarrantyFaq';

function Warranty() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="about">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title={"LIFETIME DENTAL WARRANTY AT PRISTINE SMILE"} 
          about={"If it breaks, we fix it. No cost to you."} />
      </AnimatedSection>

      <AnimatedSection id='warrantyStatementSection' delay={400}>
        <WarrantyStatementSection />
      </AnimatedSection>

      <AnimatedSection id='warrantyCoverage' delay={600}>
        <WarrantyCoverage />
      </AnimatedSection>

      <AnimatedSection id='warrantyTerms' delay={600}>
        <WarrantyTerms />
      </AnimatedSection>

      <AnimatedSection id='warrantyMaintenance' delay={600}>
        <WarrantyMaintenance />
      </AnimatedSection>

      <AnimatedSection id='warrantyExclusions' delay={600}>
        <WarrantyExclusions />
      </AnimatedSection>

      <AnimatedSection id='warrantyPhilosophy' delay={600}>
        <WarrantyPhilosophy />
      </AnimatedSection>

      <AnimatedSection id='warrantyFaq' delay={600}>
        <WarrantyFaq />
      </AnimatedSection>

      <AnimatedSection id='visitUs' delay={1000}>
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id='bookVisit' delay={1200}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default Warranty;